import React, { Fragment, useEffect, useState } from "react";
import PageLayout from "../Layouts/PageLayout";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  OfflineBankSettingsGetAction,
  OfflineBankSettingsUpdateAction,
} from "../../Redux/Action/SubscriptionPaymentAction";

function OfflineBankSettingsEdit() {
  const dispatch = useDispatch<any>();
  const getState = useSelector((state: any) => state.OfflineBankSettingsGetState);
  const updateState = useSelector((state: any) => state.OfflineBankSettingsUpdateState);
  const [form, setForm] = useState({
    account_holder_name: "",
    bank_name: "",
    account_number: "",
    iban: "",
    swift_bic: "",
    payment_instructions: "",
  });

  useEffect(() => {
    dispatch(OfflineBankSettingsGetAction({}));
  }, [dispatch]);

  useEffect(() => {
    const d = getState?.data?.data;
    if (d) {
      setForm({
        account_holder_name: d.account_holder_name || "",
        bank_name: d.bank_name || "",
        account_number: d.account_number || "",
        iban: d.iban || "",
        swift_bic: d.swift_bic || "",
        payment_instructions: d.payment_instructions || "",
      });
    }
  }, [getState?.data]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(OfflineBankSettingsUpdateAction(form));
  };

  return (
    <Fragment>
      {getState?.loading ? <Spinner /> : ""}
      <PageLayout
        title="Offline payment bank settings"
        breadcrumbs={{
          secLast: { link: "/offline-bank-settings", name: "Bank settings" },
        }}
        buttons={[
          {
            url: "/subscription-payment-requests",
            className: "btn btn-secondary",
            text: "Pending payments",
            show: true,
          },
        ]}
      >
        <form className="card card-body" onSubmit={onSubmit}>
          <div className="row gy-3">
            <div className="col-md-6">
              <label className="form-label">Account holder name</label>
              <input
                className="form-control"
                name="account_holder_name"
                value={form.account_holder_name}
                onChange={onChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Bank name</label>
              <input className="form-control" name="bank_name" value={form.bank_name} onChange={onChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Account number</label>
              <input
                className="form-control"
                name="account_number"
                value={form.account_number}
                onChange={onChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">IBAN</label>
              <input className="form-control" name="iban" value={form.iban} onChange={onChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">SWIFT / BIC</label>
              <input className="form-control" name="swift_bic" value={form.swift_bic} onChange={onChange} />
            </div>
            <div className="col-12">
              <label className="form-label">Payment instructions</label>
              <textarea
                className="form-control"
                rows={4}
                name="payment_instructions"
                value={form.payment_instructions}
                onChange={onChange}
              />
            </div>
          </div>
          <button type="submit" className="btn btn-primary mt-3" disabled={updateState?.loading}>
            Save
          </button>
        </form>
      </PageLayout>
    </Fragment>
  );
}

export default OfflineBankSettingsEdit;
